// extracted by mini-css-extract-plugin
module.exports = {"blurBG":"modal_blurBG__1dRfE","modal":"modal_modal__5_5_U","content":"modal_content__zC_bh","cancel":"modal_cancel__XR_Uk"};